/**
 * @property {boolean} isReadOnly - read only attributes are rendered as disabled and not validated. All attributes are by default not read only.
 * @property {boolean} isHidden - hidden attributes are not rendered in service detail. All attributes are by default not hidden.
 */
export class Attribute {
  constructor() {
    this.isReadOnly = false;
    this.isHidden = false;
  }
}
